import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OperatorService } from '../../_services/fundraising/operator.service';
import { PosOperator } from '../../_models/fundraising/PosOperator';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../_services/dialog.service';
import { IAngularMyDpOptions } from 'angular-mydatepicker';
import {isEarlierThanTodayValidator} from "../../_services/date-picker-validator.service";

@Component({
    selector: 'app-operator-create',
    templateUrl: './operator-create.component.html',
    styleUrls: ['./operator-create.component.css']
})

export class OperatorCreateComponent implements OnInit, AfterContentChecked  {

    public operatorForm: FormGroup;

    public operatorId: number;
    public operator: PosOperator;
    public isEarlyDate: boolean = false

    public operatorFC(name: string)  {
        return this.operatorForm?.controls[name];
    }

    public locationFC(name: string)  {
        return (this.operatorForm.controls['location'] as FormGroup)?.controls[name];
    }

    @ViewChild('expiresPicker', { read: ElementRef, static: false })
    public expiresPicker: ElementRef;

    public expiresDateOptions: IAngularMyDpOptions;

    constructor(
        private operatorService: OperatorService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private fb: FormBuilder,
        private cdRef: ChangeDetectorRef
    ) { }


  ngAfterContentChecked(): void {
    this.cdRef.detectChanges()
  }

    ngOnInit(): void {
        this.spinner.show();

        this.expiresDateOptions = {
            markCurrentDay: true,
            dateFormat: 'mm/dd/yyyy',
            dateRange: false
        };

        this.expiresDateOptions.stylesData = {
            selector: 'expiresPicker',
            styles: `
              .expiresPicker .myDpSelectorAbsolute { right: 100px !important; z-index: 100; }
              .myDpSelectorArrowLeft:after, .myDpSelectorArrowLeft:before { visibility: hidden; }
            `
          };

        this.route.params
        .subscribe(params => {
          this.operatorId = params['id'] ?? 0;
            this.operatorService.getById(this.operatorId)
                .subscribe(l => {
                    this.operator = l;

                    this.createForm(this.operator);

                    this.spinner.hide();

                },
                error => {
                    this.dialogService.alert("Oops something went wrong...", error.error, this.viewRef);
                    this.spinner.hide();
                }
            )
        });
    }

    createForm(operator: PosOperator) {
        this.operatorForm = this.fb.group({
            operatorId: [operator?.operatorId || 0, Validators.required],
            name: [operator?.name, Validators.required],
            email: [operator?.email, [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
            phoneNumber: [operator?.phoneNumber, [Validators.required, Validators.pattern(/^[\s.]*(\d{1,2}[\s.-]*)?\(?\d{3}\)?[\s.-]*\d{3}[\s.-]*\d{4}[\s.]*$/)]],
            expires: [operator?.expires ? { isRange: false, singleDate: { jsDate: new Date(operator?.expires) } } : { isRange: false, singleDate: { jsDate: new Date() } } ,[ Validators.required, isEarlierThanTodayValidator(new Date(Date.now()))]],
            guest: [operator?.guest || false, Validators.required],
            username: [operator?.username],
            guestPassword: [''],
            guestPassword2: [''],
        });

    }

    guestChange() {
      if (this.operatorFC('guest').value && !this.operator?.verified) {
        this.operatorFC('guestPassword').setValidators([Validators.required, Validators.minLength(5)]);
        this.operatorFC('guestPassword2').setValidators([Validators.required, Validators.minLength(5)]);
        this.operatorFC('username').setValidators([Validators.required, Validators.minLength(5)]);
        this.operatorFC('location').enable();
        } else {
          this.operatorFC('guestPassword').setValidators(null);
          this.operatorFC('guestPassword2').setValidators(null);
          this.operatorFC('username').setValidators(null);
          this.operatorFC('location')?.disable();
        }
      this.operatorForm.controls.location?.updateValueAndValidity();
      this.operatorFC('guestPassword').updateValueAndValidity();
      this.operatorFC('guestPassword2').updateValueAndValidity();
      this.operatorFC('username').updateValueAndValidity();
      this.operatorFC('expires').updateValueAndValidity();
    }

    hasOperatorErrors() {
        return this.operatorForm && !this.operatorForm.valid
        || (this.operatorForm && this.operatorFC('guest').value && this.operatorFC('guestPassword').value != this.operatorFC('guestPassword2').value);
    }

    hasLocationErrors() {
        return this.operatorForm && this.operatorForm.controls.location && this.operatorFC('guest').value && this.operatorForm.controls.location.invalid;
    }

    hasPickerError() {
      this.isEarlyDate = this.operatorFC('expires').value.singleDate.jsDate < Date.now()
      return this.operatorForm && this.isEarlyDate
    }


    save() {

        this.guestChange();

        const invalid = [];
        const controls = this.operatorForm.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }

        if (this.hasOperatorErrors() || this.hasLocationErrors() || this.hasPickerError()) {
          this.operatorForm.markAllAsTouched();
          this.operatorForm.markAsDirty();

          this.operatorForm.controls.location.markAllAsTouched();
          this.operatorForm.controls.location.markAsDirty();
          return;
        }



        this.spinner.show();

        const operatorData = new PosOperator(this.operatorForm.getRawValue());

        operatorData.expires = this.operatorForm.controls.expires.value.singleDate.jsDate;

        if(this.operatorId > 0) {
            this.operatorService.update(operatorData).subscribe(
              () => {
                this.spinner.hide();
                this.navigateUp();
              },
              error => {
                this.spinner.hide();

                this.dialogService.error(error, "Unable to update operator", this.viewRef);
              }
            );
          } else {
            this.operatorService.create(operatorData).subscribe(
              () => {
                this.spinner.hide();
                this.navigateUp();
              },
              error => {
                this.spinner.hide();

                let message = error.error;
                if (error.error instanceof ProgressEvent) {
                    message = error.statusText;
                }

                this.dialogService.alert("Unable to create operator", message, this.viewRef);
              }
            );
          }


    }

    openOperatorInfo() {
        this.dialogService.alert('Station Operators',
        'Station Operators are the feet on the ground selling tickets during your event. Using this page, you will create \
        their credentials allowing your volunteers or staff to sign into your Point of Sale (POS) app. We recommend assigning individual \
        accounts for each person selling admission to your fundraising event, however if you aren\'t sure who\'s going to be working,\
        you can create a guest account for the group.', this.viewRef, 'Ok I guess');
    }


    public  navigateUp() {
        this.router.navigate([this.operatorId > 0 ? '../../' : '../'], {relativeTo: this.route});
      }


}
